<template>
    <select-box-component v-model="selectedRegionIso"
                          :options="regions"
                          @change="onRegionChange"
                          name="region"
                          :title="translate.home.region"
                          :description="translate.home.regionDescription"
                          :triggerClass="['custom-dropdown-button', !isLanguageNeeded ? 'align-left' : '']"
                          :dropdownPosition="dropdownPosition"
                          type="link"
                          class="cursor-pointer"
    />
</template>

<script>
import SelectBoxComponent from "@/components/partials/SelectBoxComponent.vue";
import {regionIsoEnum} from "@/core/enums/regionIsoEnum";
import cookiesEnum from "@/core/constants/cookiesEnum";
import {mapState} from "vuex";
import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import IconComponent from "@/components/global/IconComponent.vue";
import {fa_arrow_right, fa_globe_americas} from "@/core/constants/icons";
import {removeCookie, setCookie} from "@/core/utils/helpers/cookieHelper";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";

const data = () => {
    return {
        store: $store,
        selectedRegionIso: regionIsoEnum.GERMANY,
    }
}

function created() {
    const regionPath = process.env.MIX_REGION_PATH
    if (regionPath) {
        this.selectedRegionIso = regionPath;
    }
}

function onRegionChange(regionIso) {
    setCookie(cookiesEnum.REDIRECT_TO_REGION_OVERRIDE, regionIso);
    removeCookie(cookiesEnum.IGNORE_REGION_REDIRECT);

    let url = `/${regionIso}/`;

    if (regionIso === regionIsoEnum.GERMANY) {
        url = '/';
    }

    window.location.href = url;
}

function getFlagIconCdnLink(iso) {
    const cdnFolder = `${process.env.MIX_CDN2_URL}flagsSVGs`;

    switch (iso) {
        case regionIsoEnum.AUSTRIA:
            return `${cdnFolder}/austria.svg`;
        case regionIsoEnum.AUSTRALIA:
            return `${cdnFolder}/australia.svg`;
        case regionIsoEnum.ITALY:
            return `${cdnFolder}/italy.svg`;
        case regionIsoEnum.GERMANY:
            return `${cdnFolder}/germany.svg`;
        case regionIsoEnum.UNITED_KINGDOM:
            return `${cdnFolder}/unitedKingdom.svg`;
        case regionIsoEnum.BRAZIL:
            return `${cdnFolder}/brazil.svg`;
        default:
    }
}

export default {
    components: {IconComponent, SelectBoxComponent},
    data,
    created,
    computed: {
        ...mapState(['translate', 'settings', 'locale', 'currentUser', 'regionData']),
        isLanguageNeeded() {
            return !_.has(this.regionData, 'sectionsToHide.languageSelector');
        },
        regions() {
            return [
                {
                    label: 'Österreich',
                    value: regionIsoEnum.AUSTRIA,
                    link: `/${regionIsoEnum.AUSTRIA}/`,
                    icon: this.getFlagIconCdnLink(regionIsoEnum.AUSTRIA)
                },
                {
                    label: 'Australia',
                    value: regionIsoEnum.AUSTRALIA,
                    link: `/${regionIsoEnum.AUSTRALIA}/`,
                    icon: this.getFlagIconCdnLink(regionIsoEnum.AUSTRALIA)
                },
                {
                    label: 'Deutschland',
                    value: regionIsoEnum.GERMANY,
                    link: `/`,
                    icon: this.getFlagIconCdnLink(regionIsoEnum.GERMANY)
                },
                {
                    label: 'United Kingdom',
                    value: regionIsoEnum.UNITED_KINGDOM,
                    link: `/${regionIsoEnum.UNITED_KINGDOM}/`,
                    icon: this.getFlagIconCdnLink(regionIsoEnum.UNITED_KINGDOM)
                },
                {
                    label: 'Italia',
                    value: regionIsoEnum.ITALY,
                    link: `/${regionIsoEnum.ITALY}/`,
                    icon: this.getFlagIconCdnLink(regionIsoEnum.ITALY)
                },
                {
                    label: 'Brasil',
                    value: regionIsoEnum.BRAZIL,
                    link: `/${regionIsoEnum.BRAZIL}/`,
                    icon: this.getFlagIconCdnLink(regionIsoEnum.BRAZIL)
                },
            ];
        },
        languages() {
            const languages = this.settings.languages;
            return languages ? languages.map((lang) => {
                return {
                    label: lang.localName,
                    value: lang.locale
                }
            }) : [];
        },
        selectedLanguage: {
            get() {
                return this.locale;
            },
            set(value) {
                this.onLanguageChange(value);
            },
        },
    },
    props: {
        dropdownPosition: {
            type: [String],
            default: 'bottom'
        },
    },
    methods: {
        fa_globe_americas,
        regionRelativeUrl,
        fa_arrow_right,
        getFlagIconCdnLink,
        onRegionChange,
    },
    mixins: [
        xtrackingMixin
    ]
}
</script>
